export default "__VITE_ASSET__brlNRUr5__"